<template>
  <admin-wrapper
    :straight-title="additionalModuleName"
    :moduleEnabler="moduleEnabler"
    :inputs="inputs"
    :is-form-fetched="isFormFetched"
    @save="save"
  >
    <template #infrastructure_collisions_layers.input="data">
      <v-col cols="3">
        <data-input v-bind="data" v-model="selectedLayers">
          <template #selection="{ item, index }">
            <v-tooltip v-if="index <= 1" bottom color="font">
              <template #activator="{ on }">
                <v-chip v-on="on" x-small>
                  <div class="text-truncate">{{ item.text }}</div>
                </v-chip>
              </template>
              {{ item.text }}
            </v-tooltip>
            <div v-if="index === 2" class="grey--text caption" style="white-space: nowrap !important;">
              {{ otherLayersText }}
            </div>
          </template>
        </data-input>
      </v-col>
    </template>
  </admin-wrapper>
</template>
<script>
import { call, get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import DataInput from '@/components/DataInput';

export default {
  name: 'InfrastructureCollisionsSettings',
  components: { AdminWrapper, DataInput },
  computed: {
    additionalModuleName: get('admin/additionalModules.INFRASTRUCTURE_COLLISIONS.verbose_name'),
    isModuleEnabled: get('admin/settingsValues@infrastructure_collisions_module_enabled'),
    selectedLayersSettingValue: get('admin/settingsValues@infrastructure_collisions_layers'),
    layers: get('layers/layers'),
    layersArray() {
      return this.$_objectToArray(this.layers);
    },
    layersFilterArray() {
      return this.layersArray.filter(layer => layer.type === 'features_layer');
    },
    layersMappedArray() {
      return this.layersFilterArray.map(layer => {
        const { id, name } = layer;
        return { value: id, text: name };
      });
    },
    inputs() {
      return [
        {
          name: 'infrastructure_collisions_layers',
          translationPath: 'admin.infrastructureCollisions.collisionsLayers',
          subtitle: 'admin.infrastructureCollisions.collisionsLayersSubtitle',
          rules: [v => !!v || v.length > 0 || 'rules.required'],
          dataType: {
            name: 'select',
          },
          multiple: true,
          autoConvertSelect: false,
          align: 'start',
          items: this.layersMappedArray,
        },
      ];
    },
    moduleEnabler() {
      return {
        name: 'infrastructure_collisions_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
    otherLayersText() {
      const otherAttributesLength = this.selectedLayers.length - 2;
      return `(+${this.$i18n.tc('admin.other', otherAttributesLength)})`;
    },
  },
  data: () => ({
    isFormFetched: false,
    selectedLayers: [],
  }),
  methods: {
    editSingleSetting: call('admin/editSingleSetting'),
    getLayers: call('layers/getLayers'),
    async init() {
      await this.getLayers();
      this.selectedLayers = this.selectedLayersSettingValue
        ? JSON.parse(JSON.stringify(this.selectedLayersSettingValue))
        : [];
      this.isFormFetched = true;
    },
    async save() {
      this.editSingleSetting({
        key: 'infrastructure_collisions_layers',
        body: {
          value: this.selectedLayers,
        },
      });
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFormFetched = false;
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFormFetched = true;
    }
  },
};
</script>
